module.exports = __webpack_public_path__ + "static/media/green_circle_tick.fac06438.svg";